module.exports = __webpack_public_path__ + "static/media/kit.46d9af44.jpg";